"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.once = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const once = fn => {
  let called = false;
  let result;
  const newFn = function () {
    if (called) {
      return result;
    }
    called = true;
    result = fn(...arguments);
    return result;
  };
  return newFn;
};
exports.once = once;
//# sourceMappingURL=once.js.map